export default __webpack_public_path__ + "static/media/chuseok5.b2f4e6d3.png";